<template>
  <div>
    <v-tooltip
      bottom
      v-for="(menu, index) in menus"
      :key="`public-menus-${index}`"
    >
      <v-btn slot="activator" :to="menu.path" :color="getColor(menu)" icon>
        <v-icon :color="getInvertedColor(menu)">{{ menu.icon }}</v-icon>
      </v-btn>
      <span>{{ menu.title }}</span>
    </v-tooltip>
  </div>
</template>

<script>
import PublicMenus from "@/constants/publicMenus";
import { mapState } from "vuex";

export default {
  name: "public-menus",
  data() {
    return {
      menus: PublicMenus
    };
  },
  computed: {
    ...mapState("sistem", ["sistem"])
  },
  methods: {
    getColor(menu) {
      return this.$route.path == menu.path ? this.sistem.app_theme : "";
    },
    getInvertedColor(menu) {
      return this.$route.path != menu.path ? this.sistem.app_theme : "white";
    }
  }
};
</script>
